import React, { useEffect, useState } from "react";
import Paper from "@mui/material/Paper";
import TableContainer from "@mui/material/TableContainer";
import Table from "@mui/material/Table";
import TableHead from "@mui/material/TableHead";
import TableBody from "@mui/material/TableBody";
import TableRow from "@mui/material/TableRow";
import Typography from "@mui/material/Typography";
import TablePagination from "@mui/material/TablePagination";
import { Select, MenuItem, Input, IconButton } from "@mui/material";
import Checkbox from "@mui/material/Checkbox";
import InputAdornment from "@mui/material/InputAdornment";
import axios from "axios";
import FormControl from "@mui/material/FormControl";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { ReactComponent as SortDown } from "../../assets/images/SortDown.svg";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import { styled } from "@mui/material/styles";
import Header from "../dashboard/Header";
import AtcPartRequestDialog from "./AtcPartRequestDialog";
import "../../styles/ownerPartRequest.css";
import { ReactComponent as DropdownIcon } from "../../assets/images/DropdownIcon.svg";
import { ReactComponent as SearchIcon } from "../../assets/images/SearchIcon.svg";
import { ReactComponent as DatePickerIcon } from "../../assets/images/DatePickerIcon.svg";
import AtcPartCreationDialog from "./AtcPartCreationDialog";
import { automationHttpRequest } from "../../api/httpRequests";
import AtcModificationDialog from "./AtcModificationDialog";
import { ToastContainer, toast } from "react-toastify";
import PartRequestFilter from "../dashboard/PartRequestFilter";
import Popover from "@mui/material/Popover";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: "#FAF0F0",
    color: "rgb(198, 0, 61)",
    fontSize: "15px",
    fontWeight: "600",
    fontFamily: "Verdana",
    border: "2px solid #ccc", // Add border style
    borderBottom: "2px solid #BDBDBD", // Add bottom border style
    padding: "32px 20px",
    position: "sticky",
    top: 0,
    zIndex: 2,
    minWidth: "220px",
    textAlign: "center",
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
    position: "sticky",
    top: 0,
    zIndex: 2,
    backgroundColor: "red",
    border: "1px solid #BDBDBD", // Add border style
    borderBottom: "2px solid #BDBDBD", // Add bottom border style
  },
}));

const StyledTable = styled(Table)({
  border: "1px solid #BDBDBD",
});

const AtcPartRequestHistory = () => {
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [maxRows, setMaxRows] = React.useState(0);
  const [selectedOption, setSelectedOption] = useState("");
  const [searchText, setSearchText] = useState("");
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [selectedOptions, setSelectedOptions] = useState([]);
  const [tableData, setTableData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [partRequestNumber, setPartRequestNumber] = useState();
  const [partRequestDialogOpen, setPartRequestDialogOpen] = useState(false);
  const [partRequestDetails, setPartRequestDetails] = useState();
  const [dialogLoading, setDialogLoading] = useState(false);
  const [dfDetais, setDfDetais] = useState();
  const [partCreationDialogOpen, setPartCreationDialogOpen] = useState(false);
  const [partCreationDetails, setPartCreationDetails] = useState();
  const [partModificationDialogOpen, setPartModificationDialogOpen] =
    useState(false);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [column_Name, setColumnName] = React.useState("");
  const [order, setOrder] = useState("desc");
  const [filterValues, setFilterValues] = useState({});
  const [orderBy, setOrderBy] = useState("");
  const [searchFilterOPen, setSearchFilterOpen] = useState(false);
  const [selectedFilterValues, setSelectedFilterValues] = useState({});
  const [partModificationDetails, setPartModificationDetails] = useState();
  const [actionType, setActionType] = useState([
    "Extension",
    "Modification",
    "Creation",
  ]);
  const [partModificationType, setPartModificationType] = useState();

  useEffect(() => {
    localStorage.setItem("request_id", JSON.stringify([]));
    localStorage.setItem("material_number", JSON.stringify([]));
    localStorage.setItem("date_of_submission", JSON.stringify([]));
    localStorage.setItem("request_type", JSON.stringify([]));
    localStorage.setItem("submitted_by", JSON.stringify([]));
    localStorage.setItem("plant_name", JSON.stringify([]));
    localStorage.setItem("status", JSON.stringify([]));
  }, []);

  useEffect(() => {
    fetchPartRequestHistory();
  }, [
    actionType,
    fromDate,
    toDate,
    page,
    rowsPerPage,
    order,
    orderBy,
    selectedFilterValues,
  ]);

  const handleFilterData = (data) => {
    let filterResult = {};
    if (data?.request_id) {
      filterResult.request_id = data?.request_id || [];
    }
    if (data?.material_number) {
      filterResult.material_number = data?.material_number || [];
    }
    if (data?.date_of_submission) {
      filterResult.date_of_submission = data?.date_of_submission || [];
    }
    if (data?.request_type) {
      filterResult.request_type = data?.request_type || [];
    }
    if (data?.submitted_by) {
      filterResult.submitted_by = data?.submitted_by || [];
    }
    if (data?.plant_name) {
      filterResult.plant_name = data?.plant_name || [];
    }
    if (data?.status) {
      filterResult.status = data?.status || [];
    }
    return filterResult;
  };

  const filteredColumns = {
    "Request ID": "request_id",
    "Material Number": "material_number",
    "Date of Submission": "date_of_submission",
    "Request Type": "request_type",
    "Submitted by": "submitted_by",
    "Requested for plant": "plant_name",
    Status: "status",
  };

  const handleRequest = (value, type) => {
    if (type === "Extension") {
      handlePartRequestDetails(value);
    }
    if (type === "Creation") {
      handlePartCreationDetails(value);
    }
    if (type === "Modification") {
      handlePartModificationDetails(value);
    }
  };

  const handlePartModificationDetails = async (value) => {
    setPartRequestNumber(value);
    setPartModificationDialogOpen(true);
    if (value) {
      setDialogLoading(true);
      try {
        const response = await automationHttpRequest.post(
          "/modification_details_for_ETC/",
          { request_id: value.toString() },
          {
            headers: {
              session_id: localStorage.getItem("session_id"),
              userEmail: localStorage.getItem("MRO_user_email"),
            },
            params: {},
          },
        );
        if (response?.data?.status) {
          setDialogLoading(false);
          const modificationData = response?.data?.data;
          const modificationRow = modificationData?.[0] || {};
          const normalizedComment =
            modificationRow?.modification_comment ||
            modificationRow?.dataowner_extension_comment ||
            modificationRow?.data_owner_extension_comment ||
            response?.data?.dataowner_extension_comment ||
            response?.data?.data_owner_extension_comment ||
            "";
          setPartModificationDetails({
            ...modificationRow,
            dataowner_extension_comment: normalizedComment,
            data_owner_extension_comment: normalizedComment,
            modification_comment:
              modificationRow?.modification_comment || normalizedComment,
          });
          setPartModificationType(response?.data?.type);
        }
      } catch (error) {
        setDialogLoading(false);
        toast.error("Unable to process the request. Please try again!", {
          position: toast.POSITION.TOP_CENTER,
          autoClose: 800,
        });
      }
    }
  };

  const fetchPartRequestHistory = async () => {
    setLoading(true);
    try {
      const response = await automationHttpRequest.post(
        "/logbook_global/",
        {
          request_type: actionType,
          from_date: handleDateFormat(fromDate)
            ? handleDateFormat(fromDate)
            : "",
          to_date: handleDateFormat(toDate) ? handleDateFormat(toDate) : "",
          page_size: rowsPerPage,
          page: page + 1,
          sort_order: order,
          sort_column: filteredColumns[orderBy],
          ...selectedFilterValues,
        },
        {
          headers: {
            session_id: localStorage.getItem("session_id"),
            userEmail: localStorage.getItem("MRO_user_email"),
          },
        },
      );

      if (response?.data?.status) {
        setTableData(response?.data?.data?.data);
        setLoading(false);
        const filterResult = handleFilterData(response?.data?.data);
        setFilterValues(filterResult);
        setAnchorEl(null);
        setMaxRows(response?.data?.data?.total_count);
      }
    } catch (error) {
      setLoading(false);
      toast.error("Unable to process the request. Please try again!", {
        position: toast.POSITION.TOP_CENTER,
      });
    }
  };

  const handleSearchfilterOpen = (event, col_name) => {
    setSearchFilterOpen(true);
    setAnchorEl(event.currentTarget);
    setColumnName(col_name);
  };

  const handleFiltersearch = (val) => {
    // fetchPartRequestHistory(val)
    setSelectedFilterValues(val);
    // setRowsPerPage(5);
    setPage(0);
    // setBoolApi(true);
    // fetchSearchFilterResult(val);
    // shouldExecuteEffectRef.current = false;
    // setFilterData(val);
  };

  const handleClose = () => {
    setAnchorEl(null);
    setSearchFilterOpen(false);
  };

  const handleRequestSort = (property, orderValue) => {
    setOrder(orderValue);
    setOrderBy(property);
  };

  const handlePartRequestDetails = (value) => {
    setPartRequestNumber(value);
    const handlePartRequest = async (value) => {
      if (value) {
        setDialogLoading(true);
        try {
          const response = await automationHttpRequest.post(
            "/etc_extension/",
            { request_id: value.toString() },
            {
              headers: {
                session_id: localStorage.getItem("session_id"),
                userEmail: localStorage.getItem("MRO_user_email"),
              },
              params: {},
            },
          );
          if (response?.data?.status) {
            setDialogLoading(false);
            const extensionData = response?.data?.data;
            const extensionRow = extensionData?.data?.[0] || {};
            const normalizedComment =
              extensionRow?.dataowner_extension_comment ||
              extensionRow?.data_owner_extension_comment ||
              extensionData?.dataowner_extension_comment ||
              extensionData?.data_owner_extension_comment ||
              extensionData?.df_data?.dataowner_extension_comment ||
              extensionData?.df_data?.data_owner_extension_comment ||
              "";
            setPartRequestDetails({
              ...extensionRow,
              dataowner_extension_comment: normalizedComment,
              data_owner_extension_comment: normalizedComment,
            });
            setDfDetais({
              ...(extensionData?.df_data || {}),
              dataowner_extension_comment: normalizedComment,
              data_owner_extension_comment: normalizedComment,
            });
          }
        } catch (error) {
          setDialogLoading(false);
          toast.error("Unable to process the request. Please try again!", {
            position: toast.POSITION.TOP_CENTER,
            autoClose: 800,
          });
        }
      }
    };
    handlePartRequest(value);
    setPartRequestDialogOpen(true);
  };

  const handlePartCreationDetails = (value) => {
    setPartRequestNumber(value);
    const handlePartCreation = async (value) => {
      if (value) {
        setDialogLoading(true);
        try {
          const response = await automationHttpRequest.post(
            "/get_ETC_History_For_Creation/",
            { request_id: value.toString() },
            {
              headers: {
                session_id: localStorage.getItem("session_id"),
                userEmail: localStorage.getItem("MRO_user_email"),
              },
              params: {},
            },
          );
          if (response?.data?.status) {
            setDialogLoading(false);
            setPartCreationDetails(response?.data?.data[0]);
          }
        } catch (error) {
          setDialogLoading(false);
          toast.error("Unable to process the request. Please try again!", {
            position: toast.POSITION.TOP_CENTER,
            autoClose: 800,
          });
        }
      }
    };
    handlePartCreation(value);
    setPartCreationDialogOpen(true);
  };

  const handleDateFormat = (value) => {
    if (!value) {
      return "";
    }
    const formatDate = (date) => {
      const day = String(date.getDate()).padStart(2, "0");
      const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are zero-based
      const year = date.getFullYear();
      return `${year}-${month}-${day}`;
    };

    const inputDate = new Date(value);
    const formattedDate = formatDate(inputDate);
    return formattedDate;
  };

  const options = ["Extension", "Modification", "Creation"];

  const handleSelectChange = (event) => {
    const selectedValues = event.target.value;
    const updatedSelectedOptions = selectedValues.includes("All")
      ? options.filter((option) => option !== "All")
      : selectedValues;
    setSelectedOptions(updatedSelectedOptions);
    setActionType(updatedSelectedOptions);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleSearchChange = (e) => {
    setSearchText(e.target.value);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    if (event.target.value === maxRows) {
      setPage(0);
    }
    setPage(0);
  };

  const handleApprove = () => {
    console.log("Approved");
  };

  const handleReject = () => {
    console.log("Rejected");
  };

  const handleDialogClose = () => {
    setPartRequestDialogOpen(false);
  };

  const handleCreationDialogClose = () => {
    setPartCreationDialogOpen(false);
  };

  const handleModificationDialogClose = () => {
    setPartModificationDialogOpen(false);
  };
  return (
    <>
      <div>
        <Header handleHideInsights={""} />
        <div style={{ margin: "20px" }}>
          <div>
            <Typography className="approval">Approval Status</Typography>
          </div>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              marginBottom: "16px",
            }}
          >
            {/* <div className="selectOption">
              <Typography className="selectHeading">
                Select Request Type
              </Typography>
              <FormControl sx={{ m: 1, width: "250px" }}>
                <Select
                  multiple
                  value={selectedOptions}
                  onChange={handleSelectChange}
                  IconComponent={() => (
                    <DropdownIcon
                      style={{
                        width: "20px",
                        position: "relative",
                        left: "-10px",
                      }}
                    />
                  )}
                  renderValue={(selected) => selected.join(", ")}
                  sx={{ height: "32px" }}
                >
                  {options.map((option) => (
                    <MenuItem key={option} value={option}>
                      <Checkbox
                        checked={selectedOptions.indexOf(option) > -1}
                      />
                      {option}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </div> */}

            <div style={{ flex: 1 }}></div>
            {/* <div style={{ display: "flex", gap: "10px" }}>
                        <button
                            // onClick={handleApply}
                            className="actionButton"
                        // disabled={filterDisable}
                        >
                            <Typography className="actionButtonName"> Reject </Typography>
                        </button>
                        <button className="actionButton"
                        // onClick={handleApply}
                        >
                            <Typography className="actionButtonName"> Approve </Typography>
                        </button>
                    </div> */}
            <div
              style={{
                // position: "relative",
                margin: "0px 20px",
                display: "flex",
              }}
            >
              {/* <IconButton className="buttonIcon">
                <SearchIcon />
              </IconButton>
              <Input
                fullWidth
                disableUnderline
                // value={search_value}
                placeholder="Search history"
                className="searchInputField"
                // onChange={handleInputChange}
                // onKeyDown={handleKeyPress}
              /> */}
            </div>
            {/* <div style={{ display: "flex", gap: "10px" }}>
              <div>
                <label htmlFor="fromDate" className="datePickerLabel">
                  From{" "}
                </label>
                <DatePicker
                  selected={fromDate}
                  onChange={(newDate) => setFromDate(newDate)}
                  dateFormat="yyyy-MM-dd"
                  maxDate={new Date()}
                  customInput={
                    <div style={{ position: "relative" }}>
                      <DatePickerIcon className="datePickerIcon" />
                      <input
                        className="datePickerInput"
                        type="text"
                        value={
                          fromDate ? handleDateFormat(fromDate) : "Choose Date"
                        }
                        readOnly
                      />
                    </div>
                  }
                />
              </div>
              <div>
                <label htmlFor="toDate" className="datePickerLabel">
                  To{" "}
                </label>
                <DatePicker
                  selected={toDate}
                  onChange={(newDate) => setToDate(newDate)}
                  dateFormat="yyyy-MM-dd"
                  maxDate={new Date()}
                  customInput={
                    <div style={{ position: "relative" }}>
                      <DatePickerIcon className="datePickerIcon" />
                      <input
                        className="datePickerInput"
                        type="text"
                        value={
                          toDate ? handleDateFormat(toDate) : "Choose Date"
                        }
                        readOnly
                      />
                    </div>
                  }
                />
              </div>
            </div> */}
          </div>
          <div>
            <Paper
              sx={{ width: "100%", mb: 2, border: "1px solid #BDBDBD" }}
              elevation={2}
            >
              {loading ? (
                <>
                  <Typography
                    sx={{
                      height: "70px",
                      fontSize: "18px",
                      padding: "20px",
                      background: "#FAF0F0 !important",
                    }}
                  >
                    Loading...
                  </Typography>
                </>
              ) : (
                <>
                  <TableContainer
                    sx={{
                      maxHeight: "600px",
                      overflowY: "auto",
                      borderBottom: "1px solid #BDBDBD",
                    }}
                  >
                    <Table
                      sx={{ minWidth: 750, border: "1px solid #BDBDBD" }}
                      aria-labelledby="tableTitle"
                    >
                      <TableHead>
                        <TableRow>
                          {Object.keys(filteredColumns).map(
                            (columnName, index) => (
                              <TableCell
                                key={columnName}
                                align="center"
                                padding="normal"
                                sx={{
                                  backgroundColor: "#FAF0F0 !important",
                                  position: "sticky",
                                  top: 0,
                                  color: "rgb(198, 0, 61)",
                                  fontSize: "14px",
                                  fontWeight: "700",
                                  fontFamily: "Verdana",
                                  height: "100px",
                                  borderRight:
                                    index <
                                    Object.keys(filteredColumns).length - 1
                                      ? "1px solid #BDBDBD"
                                      : "none",
                                }}
                                className={
                                  columnName === "Request ID"
                                    ? "fixed-column"
                                    : null
                                }
                              >
                                <div>
                                  {columnName === "Date of Submission"
                                    ? "Date Submitted"
                                    : columnName}
                                  <IconButton
                                    style={{
                                      position: "relative",
                                      left: "10px",
                                      top: "0px",
                                      zIndex: 2,
                                      fontSize: "0px",
                                    }}
                                    onClick={(e) =>
                                      handleSearchfilterOpen(e, columnName)
                                    }
                                  >
                                    <SortDown style={{ cursor: "pointer" }} />
                                  </IconButton>
                                </div>
                              </TableCell>
                            ),
                          )}
                        </TableRow>
                      </TableHead>

                      <TableBody>
                        {tableData?.map((row, index) => (
                          <TableRow
                            hover
                            role="checkbox"
                            tabIndex={-1}
                            key={row["Request ID"]}
                          >
                            {Object.values(filteredColumns).map(
                              (columnName, columnIndex) => (
                                <TableCell
                                  key={columnName}
                                  align="center"
                                  sx={{
                                    border: "1px solid #BDBDBD",
                                    fontFamily: "Verdana",
                                    textAlign: "center",
                                    borderRight:
                                      columnIndex <
                                      Object.values(filteredColumns).length - 1
                                        ? "1px solid #BDBDBD"
                                        : "none", // Add border-right
                                  }}
                                  className={
                                    columnName === "request_id"
                                      ? "fixed-column"
                                      : null
                                  }
                                >
                                  {columnName === "request_id" ? (
                                    <button
                                      style={{
                                        border: "0px",
                                        background: "transparent",
                                        color: "#C6003D",
                                        cursor: "pointer",
                                        fontWeight: 550,
                                        fontFamily: "Verdana",
                                      }}
                                      onClick={() =>
                                        handleRequest(
                                          row[columnName],
                                          row["request_type"],
                                        )
                                      }
                                    >
                                      {row[columnName]}
                                    </button>
                                  ) : (
                                    row[columnName]
                                  )}
                                </TableCell>
                              ),
                            )}
                          </TableRow>
                        ))}
                      </TableBody>
                    </Table>
                    <Popover
                      open={Boolean(anchorEl)}
                      anchorEl={anchorEl}
                      onClose={handleClose}
                      anchorOrigin={{
                        vertical: "bottom",
                        horizontal: "left",
                      }}
                      transformOrigin={{
                        vertical: "top",
                        horizontal: "left",
                      }}
                    >
                      <PartRequestFilter
                        filter_values={
                          filterValues?.[filteredColumns?.[column_Name]]
                        }
                        handleFiltersearch={handleFiltersearch}
                        column_Name={column_Name}
                        filterColumns={filteredColumns}
                        searchFilterOPen={searchFilterOPen}
                        handleSearchClose={handleClose}
                        handleRequestSort={handleRequestSort}
                      />
                    </Popover>
                  </TableContainer>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                      padding: "0 16px",
                    }}
                  >
                    <Typography
                      sx={{
                        fontFamily: "Verdana",
                        marginLeft: "22px",
                      }}
                    >
                      {" "}
                      Total:{" "}
                      <span style={{ fontWeight: "600" }}>{maxRows}</span>{" "}
                      records
                    </Typography>
                    <TablePagination
                      rowsPerPageOptions={[
                        5,
                        10,
                        15,
                        50,
                        { value: maxRows, label: "All" },
                      ]}
                      component="div"
                      count={maxRows}
                      rowsPerPage={rowsPerPage}
                      page={page}
                      onPageChange={handleChangePage}
                      onRowsPerPageChange={handleChangeRowsPerPage}
                    />
                  </div>
                </>
              )}
            </Paper>
          </div>
        </div>
      </div>
      <AtcPartRequestDialog
        open={partRequestDialogOpen}
        dialogData={partRequestDetails}
        closeDialog={handleDialogClose}
        partRequestNumber={partRequestNumber}
        dialogLoading={dialogLoading}
        dfDetais={dfDetais}
      />
      <AtcPartCreationDialog
        open={partCreationDialogOpen}
        dialogData={partCreationDetails}
        closeDialog={handleCreationDialogClose}
        partRequestNumber={partRequestNumber}
        dialogLoading={dialogLoading}
      />
      <AtcModificationDialog
        open={partModificationDialogOpen}
        dialogData={partModificationDetails}
        closeDialog={handleModificationDialogClose}
        modificationType={partModificationType}
        partRequestNumber={partRequestNumber}
        dialogLoading={dialogLoading}
      />
    </>
  );
};

export default AtcPartRequestHistory;
